document.addEventListener("DOMContentLoaded", () => {
    const buttons = document.querySelectorAll(".kits-buttons button");
    const imgElement = document.getElementById("pdImg");
    const priceElement = document.getElementById("pdPrice");

    // Function to update the image, price, and active class
    const updateProductDetails = (button) => {
      const newImg = button.getAttribute("data-pdImg");
      const newPrice = button.getAttribute("data-pdPrice");
  
      imgElement.src = newImg;
      priceElement.textContent = newPrice;
  
      // Check if the clicked button already has the "active" class
      if (button.classList.contains("active")) {
        console.log("Removing active class");
        button.classList.remove("active"); // Remove the "active" class
      } else {
        console.log("Adding active class");
        // Remove active class from all buttons
        buttons.forEach(btn => btn.classList.remove("active"));
        button.classList.add("active"); // Add the "active" class to the clicked button
        showModalAnchor.setAttribute('data-modal-id', button.getAttribute('data-modal-id'));
        closeButtons.forEach(closeBtn => {
          closeBtn.parentElement.parentElement.style.display = "none";
        });
        const modalId = showModalAnchor.getAttribute("data-modal-id");
        const modal = document.getElementById(modalId);
        if (modal) {
          modal.style.display = "flex";
        }
      }
    };

    // Add click event listener to all buttons
    buttons.forEach(button => {
      button.addEventListener("click", () => {
        updateProductDetails(button);
      });
    });

    // Mobile section
    const mobileButtons = document.querySelectorAll(".individual-kits-mob .kits-buttons button");
    const mobileImg = document.getElementById("pdImgMobile");
    const mobilePrice = document.getElementById("pdPriceMobile");

    // Function to update image, price, and active class for mobile
    const updateMobileDetails = (button) => {
      const newImg = button.getAttribute("data-pdImg");
      const newPrice = button.getAttribute("data-pdPrice");

      mobileImg.src = newImg;
      mobilePrice.textContent = newPrice;

      // Check if the clicked button already has the "active" class
      if (mobileButtons.classList.contains("active")) {
        console.log("Mobile Removing active class");
        button.classList.remove("active"); // Remove the "active" class
      } else {
        console.log("Mobile Adding active class");
        // Remove active class from all buttons
        mobileButtons.forEach(btn => btn.classList.remove("active"));

        // Add active class to the clicked button
        button.classList.add("active");
      }

      // Remove active class from all buttons
      mobileButtons.forEach(btn => btn.classList.remove("active"));

      // Add active class to the clicked button
      button.classList.add("active");
    };

  
    // Add click event listeners to mobile buttons
    mobileButtons.forEach(button => {
        button.addEventListener("click", () => updateMobileDetails(button));
    });

    // Model Box Desktop
    const desktopButtons = document.querySelectorAll(".individual-kits .kits-buttons button");
    const showModalAnchor = document.querySelector(".individual-kits .show-modal");
    const modals = document.querySelectorAll(".modal");
    const closeButtons = document.querySelectorAll(".modal .close");

    // Function to close all modals
    function closeAllModals() {
      modals.forEach(modal => {
        modal.style.display = "none";
      });
    }

    // Show relevant modal on anchor click
    showModalAnchor.addEventListener("click", (e) => {
      e.preventDefault();
      // Get the modal ID from the anchor
      const modalId = showModalAnchor.getAttribute("data-modal-id");
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.style.display = "flex";
      }
    });

    // Close modals
    closeButtons.forEach(closeBtn => {
      closeBtn.addEventListener("click", () => {
        closeBtn.parentElement.parentElement.style.display = "none";
      });
    });

    // Close modal on outside click
    window.addEventListener("click", (e) => {
      modals.forEach(modal => {
        if (e.target === modal) {
          modal.style.display = "none";
        }
      });
    });        
});

var swiper = new Swiper(".thumb-slider", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      1024: {
        slidesPerView: 5.5,          
      },
  },
});

var swiper2 = new Swiper(".main-slider", {
  spaceBetween: 10,
  navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
  },
  thumbs: {
      swiper: swiper,
  },
});

document.querySelectorAll('label.bundle-item').forEach(buttonList => {
  buttonList.addEventListener("click", () => {
  buttonList.classList.toggle('active');
  let indexTo = buttonList.getAttribute('data-slide-index');
    swiper2.slideTo(indexTo);
  });
});
